var _filter, _filter2, _filter3, _filter4, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 98,
    viewBox: "0 0 106 98",
    width: 106,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 86.2048,
    width: 88.035,
    x: 1.29559,
    y: 2.20494
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1_434",
    stdDeviation: 8.5
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 123.989,
    width: 123.989,
    x: -2.34961,
    y: -2.35049
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_434",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 40.8718,
    width: 40.8718,
    x: 80.1279,
    y: 2.21396
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_434",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 53.7653,
    width: 69.3646,
    x: 25.1875,
    y: 33.5987
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.321569 0 0 0 0 0.54902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_1_434",
    mode: "normal",
    result: "effect2_dropShadow_1_434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_434",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff759f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff196e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 51.8562,
    x2: -2.7625,
    xlinkHref: "#e",
    y1: 48.6853,
    y2: 96.0512
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 34.4282,
    x2: 81.625,
    xlinkHref: "#g",
    y1: 31.2693,
    y2: 89.7237
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 101.364,
    x2: 91.8113,
    xlinkHref: "#e",
    y1: 23.3779,
    y2: 28.0227
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 76.7612,
    x2: 32.9938,
    y1: 52.8903,
    y2: 55.254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4537,
    x2: 58.6698,
    xlinkHref: "#g",
    y1: 51.3674,
    y2: 76.4285
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.4462 5.09854-33.3864 8.94586c-12.16651 3.26-17.21292 11.9997-13.95322 24.1651l8.93652 33.3515c3.2597 12.1653 11.9999 17.2109 24.1664 13.9509l33.3864-8.9458c12.1665-3.2601 17.1811-11.9912 13.9214-24.1566l-8.9365-33.3515c-3.2597-12.16536-11.9681-17.21946-24.1346-13.95946z",
    fill: "url(#f)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.333 19.8715-22.0673 5.9129c-8.0417 2.1547-11.4361 7.7116-9.3855 15.3644l5.6217 20.9806c2.0506 7.6528 7.7687 10.768 15.8103 8.6132l22.0673-5.9129c8.0417-2.1547 11.4151-7.7059 9.3645-15.3588l-5.6217-20.9805c-2.0506-7.6529-7.7477-10.7737-15.7893-8.6189z",
    fill: "#e31352"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.7002 22.6495h-32.074c-12.5411 0-20.9758 8.8046-20.9758 21.9006v30.2244c0 13.059 8.4347 21.8636 20.9758 21.8636h32.074c12.5411 0 20.9388-8.8046 20.9388-21.8636v-30.2244c0-13.096-8.3977-21.9006-20.9388-21.9006z",
    fill: "#ff749f",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.7002 22.1495h-32.074c-6.392 0-11.7714 2.2465-15.5519 6.1935-3.7787 3.945-5.9239 9.5508-5.9239 16.2071v30.2244c0 6.6382 2.1454 12.2347 5.9241 16.175 3.7804 3.9421 9.1598 6.1886 15.5517 6.1886h32.074c6.392 0 11.7624-2.2466 15.5336-6.1891 3.7694-3.9405 5.9052-9.5369 5.9052-16.1745v-30.2244c0-6.6557-2.1356-12.2614-5.905-16.2067-3.7713-3.9473-9.1418-6.1939-15.5338-6.1939z",
    stroke: "url(#h)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.564 17.214c-3.0023 0-5.4361 2.4337-5.4361 5.4359 0 3.0021 2.4338 5.4359 5.4361 5.4359 3.002 0 5.436-2.4338 5.436-5.4359 0-1.4417-.573-2.8244-1.592-3.8438-1.02-1.0194-2.402-1.5921-3.844-1.5921z",
    fill: "url(#i)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.9999 53.0922-10.5724 13.6428c-.4448.593-1.112.9799-1.8482 1.0717-.7362.0919-1.4782-.1191-2.0555-.5845l-10.1495-7.9582-9.141 11.8237c-.662 1.0511-1.9512 1.5234-3.1369 1.1492-1.1857-.3743-1.9687-1.5008-1.9053-2.7409-.0055-.6135.2013-1.2102.5855-1.6891l10.9303-14.0975c.4394-.5882 1.0977-.9749 1.8261-1.0727s1.4655.1015 2.045.553l10.1495 7.9907 8.9133-11.4664c.4285-.5912 1.0788-.9836 1.8022-1.0877s1.4581.0891 2.0364.5355c1.1946.9343 1.4256 2.6493.5205 3.8655z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.2694 66.6125-.0019.0025c-.4122.5495-1.0305.9081-1.7129.9933-.6825.0852-1.3702-.1104-1.9052-.5418l-.0022-.0016-10.1494-7.9583-.1585-.1243-.1232.1593-9.141 11.8238-.0059.0076-.0051.0081c-.6135.9741-1.8084 1.412-2.9075 1.065-1.099-.3469-1.8245-1.3909-1.7658-2.5398h.0004l-.0001-.012c-.0051-.5675.1862-1.1193.5415-1.5622h.0001l.002-.0026 10.9302-14.0976v.0001l.0022-.0029c.4072-.5451 1.0173-.9035 1.6925-.9942.675-.0906 1.358.094 1.895.5122.0002.0001.0003.0002.0005.0003l10.1486 7.9902.1582.1245.1235-.1589 8.9133-11.4664h.0001l.0039-.0054c.3968-.5474.9989-.9108 1.6688-1.0072.6696-.0963 1.3498.0825 1.8851.4954 1.1088.8676 1.3229 2.4593.4828 3.5883l-.0395.0531v.0628z",
    stroke: "url(#k)",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.991345c535722309c903e3e6bf4933e3.svg";
export { ForwardRef as ReactComponent };